/*eslint-disable */
import React, { useState } from 'react';
import Education from './Education';
import Skills from './Skills';
import Experience from './Experience';
import Soft from './Soft';

export const experienceYears = new Date().getFullYear() - 2019;

const MyResume = () => {
  const resumes = [
  {
    name: 'Experience',
    component: Experience,
  },
  {
    name: 'Skills',
    component: Skills,
  },
  {
    name: 'Soft Skills',
    component: Soft,
  },
    {
    name: 'Education',
    component: Education,
  }];

  const [activeSlide, setActiveSlide] = React.useState(resumes[0].component);

  const handleClick = (index) => {
    const newSlide = resumes[index].component;
    setActiveSlide(newSlide);
    return activeSlide === resumes[index].component ? 'active' : '';
  };

  return (
    <section id="resume" className="myresume flex-column">
      <h6 className="myprofile__subheading">
        {experienceYears}
        + YEARS OF EXPERIENCE
      </h6>
      <h1 className="myprofile__heading">My Resume</h1>
      <div className="myresume__item">
        {resumes.map((resume, index) => <span className={`myresume__heading ${activeSlide.props.dataset === resume.name ? 'active' : ''}`} onClick={() => { handleClick(index); }}>{resume.name === 'Skills' ? 'Professional Skills' : resume.name}</span>)}
      </div>
      <div>{activeSlide}</div>
    </section>
  );
};

export default MyResume;
